import { render } from "./UpdatePasswordDialog.vue?vue&type=template&id=00a5e762"
import script from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__